import axios from "axios";
import { BASE_URL } from "./apiUrl";
import Cookies from "js-cookie";
import { getHeaders } from "./getMethod/getMethod";
import { Member, SetAuthenticated, SetUser } from "@/lib/utils";
import moment from "moment";

export const mobileLoginUser = async (formData: {
  mobile: string;
  phoneCode: string;
}) => {
  const response = await axios.post(`${BASE_URL}/auth/login`, formData);
  return response.data;
};

export const loginUser = async (formData: {
  email: string;
  password: string;
}) => {
  const response = await axios.post(`${BASE_URL}/auth/login`, formData);
  return response.data;
};

export const forgotPasswordHandler = async (formData: { email: string }) => {
  const response = await axios.post(
    `${BASE_URL}/auth/forgot-password`,
    formData
  );
  return response.data;
};

export const verifyEmailHandler = async (formData: {
  email: string;
  otp: string;
}) => {
  const response = await axios.post(`${BASE_URL}/auth/verify-email`, formData);
  return response.data;
};

export const resetPasswordHandler = async (formData: {
  email: string;
  password: string;
  otp: string;
}) => {
  const response = await axios.post(
    `${BASE_URL}/auth/reset-password`,
    formData
  );
  return response.data;
};

export const changePasswordHandler = async (formData: {
  email: string;
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axios.put(
    `${BASE_URL}/user/change-password`,
    formData,
    getHeaders()
  );
  return response.data;
};

export const resendOtpEmail = async (resendData: {
  email: string;
  reson: string;
}) => {
  const response = await axios.post(`${BASE_URL}/auth/resend-otp`, resendData);
  return response.data;
};

export const resendOtpApiCall = async (resendData: {
  mobile: string;
  phoneCode: string;
  reson: string;
}) => {
  const response = await axios.post(`${BASE_URL}/auth/resend-otp`, resendData);
  return response.data;
};

export const mobileOtpVerfication = async (formData: {}) => {
  const response = await axios.post(`${BASE_URL}/auth/verify-otp`, formData);
  return response.data;
};
export const emailOtpVerfication = async (formData: {}) => {
  const response = await axios.post(`${BASE_URL}/auth/verify-otp`, formData);
  return response.data;
};

export const fetchCurrentEvents = async () => {
  const response = await axios.get(`${BASE_URL}/event`);
  return response.data;
};

export const fetchPastSeasons = async () => {
  const response = await axios.get(`${BASE_URL}/season/past-seasons`);
  return response.data;
};

export const fetchUserDetails = async (
  setAuthenticated: SetAuthenticated,
  setUser: SetUser
  // addSelectedUser: (user: Member) => void,
  // selectedUsers: Member[],
  // removeSelectedUser: (id: string) => void
) => {
  const token = Cookies.get("token");

  if (!token) {
    setAuthenticated(false);
    return;
  }

  setAuthenticated(true);
  try {
    const response = await axios.get(`${BASE_URL}/user/me`, getHeaders());

    const userCredential = {
      name: response.data.data.name,
      email: response.data.data.email,
      mobile: response.data.data.mobile,
      phoneCode: response.data.data.phoneCode,
      profileImage: response.data.data.profileImage,
      state: response.data.data.state,
      isBlocked: response.data.data.isBlocked,
    };

    if (response.data.data.isBlocked) {
      setAuthenticated(false);
      Cookies.remove("token");
    }
    setUser(userCredential);

    // if (selectedUsers.length !== 0) {
    //   selectedUsers.forEach((user) => {
    //     if (user.isPrimary) {
    //       removeSelectedUser(user.id);
    //       const addUser = {
    //         id: selectedUsers[0].id,
    //         name: response.data.data.name,
    //         email: response.data.data.email,
    //         mobile: response.data.data.mobile,
    //         phoneCode: response.data.data.phoneCode,
    //         birthDate: response.data.data.user_detail.birthDate,
    //         bloodGroup: response.data.data.user_detail.bloodGroup,
    //         gender: response.data.data.user_detail.gender,
    //         isPrimary: true,
    //         jersySize: response.data.data.user_detail.jerseySize,
    //         user: {
    //           profileImage: response.data.data.profileImage,
    //           status: response.data.data.status,
    //         },
    //       };
    //       addSelectedUser(addUser);
    //     }
    //   });
    //   // removeSelectedUser(selectedUsers[0].id);
    // }
    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    Cookies.remove("token");
    setAuthenticated(false);
    throw error;
  }
};

export const getUserDetails = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/user/me`, getHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

export const fetchEventDetailsById = async (id: string) => {
  const response = await axios.get(`${BASE_URL}/event/${id}`);
  return response.data;
};

export const fetchPastCardDetails = async (id: string) => {
  const response = await axios.get(`${BASE_URL}/event/${id}/past-season`);
  return response.data;
};

export const updateUserDetail = async (formData: {
  userId: string;
  name: string;
  email: string;
  mobile: string;
  phoneCode: string;
  birthDate: string;
  gender: string;
  jerseySize: string;
  country: string;
  state: string;
  city: string;
  address: string;
  pinCode: string;
  emergencyContactName: string;
  emergencyContactNumber: string;
  profileImage?: File;
  userDocs?: File;
}) => {
  const response = await axios.post(
    `${BASE_URL}/user`,
    formData,
    getHeaders(true)
  );

  return response.data;
};

interface FetchAllMembersResponse {
  data: Member[];
}

export const fetchAllMembers = async (
  selectedUsers: Member[],
  addSelectedUser: (user: Member) => void
): Promise<Member[]> => {
  const response = await axios.get<FetchAllMembersResponse>(
    `${BASE_URL}/members`,
    getHeaders()
  );
  if (selectedUsers.length === 0) {
    response.data.data.forEach((user) => {
      if (user.isPrimary && user.user.status != "REJECTED") {
        addSelectedUser(user);
      }
    });
  }
  // else {
  //   selectedUsers.forEach((selectedUser) => {
  //     response.data.data.forEach((user) => {
  //       if (selectedUser.id === user.id) {
  //         updateUser(user.id, user);
  //       }
  //     });
  //   });
  // }

  return response.data.data;
};

export const fetchSeasonCategory = async (id: string) => {
  const response = await axios.get(`${BASE_URL}/event/category/${id}`);
  return response.data.data;
};

// adding a newe member
export const addNewMember = async (
  formData: {
    name: string;
    email: string;
    mobile: string;
    phoneCode: string;
    birthDate: string;
    gender: string;
    jerseySize: string;
    bloodGroup: string;
  },
  action: { action: string }
) => {
  const token = Cookies.get("token");
  const response = await axios.post(
    `${BASE_URL}/members?action=${action}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

interface UpdateMemberFormData {
  name: string;
  email: string;
  mobile: string;
  phoneCode: string;
  birthDate: string;
  gender: string;
  jerseySize: string;
  bloodGroup: string;
}

export const updateMember = async (
  memberId: string,
  formData: UpdateMemberFormData
) => {
  const token = Cookies.get("token");
  // console.log("formData is there ", formData);
  formData.birthDate = moment(formData.birthDate).format("YYYY-MM-DD");

  const response = await axios.put(
    `${BASE_URL}/members/${memberId}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const deleteMember = async (memberId: string) => {
  const token = Cookies.get("token");
  const response = await axios.delete(`${BASE_URL}/members/${memberId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

interface RegistrationData {
  name: string;
  email: string;
  mobile: string;
  phoneCode: string;
  birthDate: string;
  gender: string;
  jerseySize: string;
  bloodGroup: string;
  [key: string]: any; // Add additional properties as needed
}

export const addRegistration = async (
  seasonId: string,
  registrationData: RegistrationData
) => {
  const token = Cookies.get("token");
  const response = await axios.post(
    `${BASE_URL}/registration/${seasonId}`,
    registrationData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const checkPaymentStatus = async (orderId: string) => {
  const token = Cookies.get("token");
  const response = await axios.get(`${BASE_URL}/payment/status/${orderId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response.data.data;
};

export const subscribeNewsletter = async (email: string) => {
  const response = await axios.post(`${BASE_URL}/news-letter/add-newsletter`, {
    email,
  });
  return response.data;
};

// Function to fetch access token
export const getAccessToken = async () => {
  const response = await axios.get(
    "https://www.universal-tutorial.com/api/getaccesstoken",
    {
      headers: {
        Accept: "application/json",
        "api-token":
          "K1Uh19gGEaR2ZfiBcnxmjC6mOwj1aOBn1CEIgYXnqWXWkALuTEr-dM23wbTobRxOU_c",
        "user-email": "grandtheftautok5@gmail.com",
      },
    }
  );
  return response.data;
};

// Function to fetch countries
//@ts-ignore
export const getCountriesData = async (token) => {
  const response = await axios.get(
    "https://www.universal-tutorial.com/api/countries",
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const fetchDeletedEvent = async () => {
  const response = await axios.get(`${BASE_URL}/instagram/deleted-event`);
  return response.data;
};

export const fetchYouTubeData = async () => {
  const response = await axios.get(
    "https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=25&playlistId=UUlKjHJ7P8vy12gVWRU5ilug&key=AIzaSyDL-bzKfEpfVbkREGqX0cSvHJWyvxPgPcc",
    {
      headers: {
        Accept: "application/json",
      },
    }
  );
  return response.data;
};
